module.exports = __webpack_public_path__ + "static/media/wds_logo.22ff74a7.png";